import { createSelector } from "reselect";

const reducerKey = "campaigns";

export const getHasFetched = (state) => state[reducerKey].get("hasFetched");

export const getCampaignById = (state, id) => state[reducerKey].getIn(["byId", id]);

export const getCampaigns = (state) => {
  return state[reducerKey]
    .get("ids")
    .map((id) => getCampaignById(state, id))
    .sort((a, b) => {
      const positionA = a.get("position");
      const positionB = b.get("position");

      // if no position, sort to the end
      if (positionA == null) {
        return 1;
      }
      if (positionB == null) {
        return -1;
      }

      return positionA - positionB;
    });
};

export const getTotalCampaigns = (state) => state[reducerKey].get("total");
export const getError = (state) => state[reducerKey].get("error");
